import { FormControl, FormGroup } from '@angular/forms';
import { PropertyMetadata } from '../../../properties/property-types';
import { RegisterElement } from '../../element-decorator';
import { PolygonMapItem } from '../polygon-map-item';

@RegisterElement()
export class Wall extends PolygonMapItem {
    public override TypeName: string = "SolidWall";
    public override ParentType: string | null = "ParkingLevel";
    public override ParentFormGroupName: string | null = "MapItems";
    
    constructor(formGroup: FormGroup) {
        super(formGroup, "SolidWall");
        
        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
        if (!formGroup.contains('Thickness')) {
            formGroup.addControl('Thickness', new FormControl(0.3)); // 30cm default thickness
        }
        if (!formGroup.contains('WallType')) {
            formGroup.addControl('WallType', new FormControl('structural'));
        }
        
        if(formGroup.contains('StrokeColor'))
            this.OutlineColor = '#' + formGroup.get('StrokeColor')?.value;
        else
            this.OutlineColor = "#333333";
        if(formGroup.contains('FillColor'))
            this.FillColor = '#' + formGroup.get('FillColor')?.value;
        else
            this.FillColor = "#444444";
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Wall Name',
                inputType: { type: 'text' },
                order: 1,
                category: 'General'
            },
            {
                formControlName: 'Thickness',
                displayName: 'Wall Thickness',
                inputType: { 
                    type: 'dimension',
                    unit: 'meters'
                },
                order: 2,
                category: 'Dimensions'
            },
            {
                formControlName: 'WallType',
                displayName: 'Wall Type',
                inputType: { 
                    type: 'select',
                    options: [
                        { value: 'structural', label: 'Structural' },
                        { value: 'partition', label: 'Partition' }
                    ]
                },
                order: 3,
                category: 'Properties'
            }
        ];
    }

    public override default(): Wall {
        this.points = [
            { x: 0, y: 0 },
            { x: 3, y: 0 },
            { x: 3, y: 0.3 },
            { x: 0, y: 0.3 }
        ];
        return this;
    }

    public override clone(): Wall {
        return new Wall(this.formGroup);
    }

} 
